import debounce from "lodash/debounce";
import { useEffect, useRef, useState } from "react";

const useCheckOverflow = () => {
  const containerRef = useRef<HTMLUListElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      const el = containerRef.current;
      if (el) {
        const hasOverflow = el.scrollWidth > el.clientWidth;
        setIsOverflowing((prev) => (prev !== hasOverflow ? hasOverflow : prev));
      }
    };

    const debounced = debounce(checkOverflow, 100);

    window.addEventListener("resize", debounced);
    checkOverflow();

    return () => window.removeEventListener("resize", debounced);
  }, []);

  return {
    containerRef,
    isOverflowing,
  };
};

export default useCheckOverflow;
